const getProp = (parent = {}, prop, _default, values = []) => {
	if(Array.isArray(prop)){
		prop = [...prop];
	}
	if(typeof parent == 'object' && Array.isArray(prop) && prop[0] === null){
		prop.shift();
		Object.values(parent).forEach(parent => {
			getProp(parent, [...prop], _default, values);
		});
		return values;
	}
	if(Array.isArray(parent)){
		parent.forEach(parent => {
			getProp(parent, Array.isArray(prop) ? [...prop] : prop, _default, values);
		});
		return values;
	}
	if(Array.isArray(prop)){
		let _prop = prop.shift();
		parent = getProp(parent, Array.isArray(_prop) ? [..._prop] : _prop);
		if(parent !== undefined){
			if(prop.length > 0){
				getProp(parent, [...prop], _default, values);
			}else{
				values.push(parent);
			}
		}
		return values;
	}else{
		prop = typeof prop === 'string' ? prop.split('.') : 
			typeof prop === 'number' ? [prop] : 
			prop === null ? [null] : 
			[];
		while(prop.length > 0){
			if(typeof parent != 'object' || parent === null){
				return _default !== undefined ? _default : undefined;
			}
			parent = parent[prop.shift()];
			if(parent === undefined){
				return _default !== undefined ? _default : undefined;
			}
		}
		return parent;
	}
}
export default getProp;